import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Column } from 'seagull/components/Layout';
import { Typography } from 'seagull/components/Typography';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetTasksSectionTID = (parentTestId)=>getTestIds(parentTestId);
export const TasksSection = (param)=>{
    let { title, tasks, renderTask, testId } = param;
    const { TasksSectionTID } = useMemo(()=>GetTasksSectionTID(testId), [
        testId
    ]);
    if (tasks.length === 0) return null;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        testId: TasksSectionTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph3",
                weight: "bold",
                skin: "secondary",
                testId: TasksSectionTID.Title(),
                children: title
            }),
            /*#__PURE__*/ _jsx(Column, {
                gap: 24,
                children: tasks.map((task)=>/*#__PURE__*/ _jsx(Box, {
                        testId: TasksSectionTID.ItemSlot(task.jobId),
                        children: renderTask(task)
                    }, task.jobId))
            })
        ]
    });
};
